export const emailCell = "contactEmails";

export const COMPANY_COUNTRY_FIELD_ID = 207;
export const CONTACT_COUNTRY_FIELD_ID = 183;
export const COMPANY_COUNTRY_FIELD = "UF_CRM_1392601991";
export const CONTACT_COUNTRY_FIELD = "UF_CRM_1392197513";
export const CONTACT_POSITION_FIELD = "UF_CRM_1634268517946";
export const LINKEDIN_ACCOUNT_FIELD = "UF_CRM_1657813125";
export const COMPANY_1CCODE_FIELD = "UF_CRM_1750150240";
